require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-becoming-a-web-dev-follow-up-on-code-fellows.json") })
        }
      }, "path---blog-becoming-a-web-dev-follow-up-on-code-fellows");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-becoming-a-web-dev-follow-up-on-code-fellows!./.cache/json/blog-becoming-a-web-dev-follow-up-on-code-fellows.json
// module id = 723
// module chunks = 231608221292675